<template>
  <div class="container">
    <el-row>
      <el-col>
        <div class="message_content_layout">
          <el-row class="el-row-content">
            <el-col class="el-row-content-text el-row-child">
              <div class="item">当前余额</div>
              <img class="el-row-img item" src="../../../assets/images/u2850.png" alt />
              <div class="content-text item">
                ￥{{ list_data.currentBalance || 0 }}
              </div>
              <el-button size="mini" class="row-button" @click="apply_money()">申请提现</el-button>
            </el-col>
            <el-col class="el-row-content-text">
              <div class="item-span">累计获得</div>
              <div class="content-text">
                ￥{{ list_data.cumulativeGain || 0 }}
              </div>
            </el-col>
            <el-col class="el-row-content-text">
              <div class="item-span">被支付单数</div>
              <div class="content-text">{{ list_data.alreadyPaid || 0 }}</div>
            </el-col>
            <el-col class="el-row-content-text">
              <div class="item-span">提现中</div>
              <div class="content-text">￥{{ list_data.withdrawaling || 0 }}</div>
            </el-col>
            <el-col class="el-row-content-text">
              <div class="item-span">累计提现</div>
              <div class="content-text">￥{{ list_data.countWithdrawal || 0 }}</div>
            </el-col>
          </el-row>
          <div>
            <div class="wallet_content">
              <el-card shadow="hover">
                <div slot="header" class="clearfix">
                  <span>近期收支明细</span>
                </div>
                <!--判断为空-->
                <div class="emptyDataCenter" v-if="record_list == ''">
                  <emptyData></emptyData>
                </div>
                <div v-else>
                  <div class="msg_warpper" v-for="item in record_list" :key="item.index">
                    <div class="msg_content">
                      <div class="msg">
                        <span class="msg_title">
                          <span class="message msg_item" v-text="item.title"></span>
                        </span>
                      </div>
                      <span class="msg_time">
                        <span class="create_time">
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                          <span v-text="item.createTime"></span>
                        </span>
                      </span>
                    </div>
                    <span class="unread_red-text">{{ item.money_dictText }}</span>
                  </div>
                </div>
              </el-card>
              <!--分页区-->
              <!-- <el-row v-if="record_list != ''" :gutter="20" style="width:100%"> -->
              <!-- <el-col :offset="10"> -->
              <div class="pagination-container" v-if="record_list != ''">
                <el-pagination @current-change="currentPageChange" :page-size="pageList.size" :current-page="pageList.current"
                  layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
              </div>
              <!-- </el-col> -->
              <!-- </el-row> -->
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import emptyData from "@/components/common/emptyData";
import util from "@/utils";
import { getWallet, getWalletList } from "@/api/index.js";
export default {
  data() {
    return {
      list_data: "",
      record_list: [],
      pageList: {},
      status: "",
      page: 5,
      pageNo: 1,
    };
  },
  components: {
    emptyData: emptyData,
  },
  created() {
    this.readyList();
    this.recordList();
  },
  methods: {
    handleClick(tab, event) {
      console.log("this.status", this.status);
      // this.page = 1;
      // this.readyList();
    },
    currentPageChange(val) {
      console.log("val", val);
      this.pageNo = val;
      this.recordList();
    },
    /**
     * 申请提现
     */
    apply_money() {
      this.$router.push({
        path: "/index/user/wallet/addCash",
      });
    },

    /**
     * 初次获取数据
     */
    async readyList() {
      try {
        const params = {};
        let res = await getWallet(params);
        if (res.success) this.list_data = res.result;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 获取收入明细记录
     */
    async recordList() {
      try {
        const params = {
          token: util.getStore("user_token"),
          pageNo: this.pageNo,
          pageSize: this.page,
        };
        let res = await getWalletList(params);
        if (res.success) {
          this.record_list = res.result.records;
          this.pageList = res.result;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    isread(status) {
      if (status) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() { },
};
</script>
<style scoped>
.wallet_content {
  min-height: 650px;
}

.emptyDataCenter {
  min-height: 550px !important;
}

.nodata {
  display: flex;
  align-items: center;
  position: relative;
  bottom: 40px;
}

.container {
  flex: 1;
  max-width: 1540px !important;
  margin: 30px;
}
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-left: 50%;
  transform: translateX(-50%);
}
.wallet_content .el-card {
  margin-top: 10px;
  font-size: 14px;
  min-height: 4em;
  /* position: relative; */
}

.wallet_content .create_time {
  font-size: 11px;
  color: #999;
}

.wallet_content {
  line-height: 1.25rem;
  position: relative;
}

.wallet_content .unread_red-text {
  display: block;
  position: absolute;
  top: 20px;
  right: 50px;
  color: red;
  font-weight: 700;
}
.wallet_content .msg_warpper {
  position: relative;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
}
.wallet_content .msg_warpper .msg_title {
  font-size: 16px;
  font-weight: bold;
  color: #f39c12;
}

.el-row-content {
  height: 180px !important;
  border: 1px #dbdbdb solid;
  max-width: 1540px !important;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.el-row-child {
  border-right: 1px #dbdbdb solid;
}

.content-text {
  color: #00afff;
  font-weight: 700;
}

.el-row-content-text {
  text-align: center;
}

.message_content_layout .el-button {
  background-image: url("../../../assets/images/rectangle6.png");
}

.message_content_layout .item {
  margin-bottom: 15px;
}

.message_content_layout .el-row-img {
  width: 50px;
}

.message_content_layout .item-span {
  margin-bottom: 30px;
}
/**
	*把user中样式覆盖
	*/
.message_content_layout .el-card__body {
  padding: 0 !important;
}
</style>
